<template lang="html">
  <div class="main">
    <div class="name">
      <div class="title">{{message.Al162}}</div>
    </div>
    <div class="box">
      <div class="title medium">{{message.Al163}}</div>
      <div class="cell">
        <div class="mid-title">
          {{message.Al202}}
        </div>
        <div class="tr">
          <span>{{message.Al164}}: </span>
          <span>{{settingsA.folder}}</span><span class="change" @click="changeFolder">{{message.Sl127}}</span>
        </div>
        <div class="tr">
          <el-checkbox class="check-box" v-model="settingsA.accountFolder">
            {{message.Al203}}
          </el-checkbox>
        </div>
        <div class="tr">
          <el-checkbox class="check-box" v-model="settingsA.senderFolder">
            {{message.Al204}}
          </el-checkbox>
        </div>
        <div class="mid-title min">
          {{message.Sl159}}
        </div>
        <div class="tr">
          <el-radio-group v-model="settingsA.languages">
            <el-radio label="zh-cn">简体中文</el-radio>
            <el-radio label="en">English</el-radio>
          </el-radio-group>
        </div>
        <div class="mid-title min">
          {{message.Sl232}}
        </div>
        <div class="tr">
          <el-select style="width:120px" v-model="settingsA.dateFormat" size="mini">
            <el-option
              v-for="item in options2"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="tr" style="text-align:center;padding:10px 0 0 0;" v-show="showA">
           <el-button size="small" @click="setA" type="primary">{{message.Al210}}</el-button>
           <el-button size="small" @click="resetA">{{message.Fl101}}</el-button>
        </div>
      </div>
      <div class="title medium">{{message.Al165}}</div>
      <div class="cell">
        <span class="mid-title" style="margin-top:0">{{message.Al194}}</span>
        <div class="tr">
          <el-checkbox class="check-box" v-model="settings.downloadLimit.is">
            {{message.Al167}}
          </el-checkbox>
          <el-input v-if="settings.downloadLimit.is" oninput = "value=value.replace(/[^\d]/g,'')" style="width:70px;margin-left:20px" v-model="settings.downloadLimit.value" size="mini"></el-input>
          <el-select v-if="settings.downloadLimit.is" style="width:85px;" v-model="settings.downloadLimit.unit" placeholder="" size="mini">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <span v-if="settings.downloadLimit.is&&settings.downloadLimit.value !==''"> = {{downloadValue}}</span>
          <span v-if="morethanDown" style="color:red;margin-left:20px">{{this.$lang.ui.prompt.l166}}</span>
        </div>
        <div class="tr">
          <el-checkbox class="check-box" v-model="settings.uploadLimit.is">
            {{message.Al166}}
          </el-checkbox>
          <el-input v-if="settings.uploadLimit.is" oninput = "value=value.replace(/[^\d]/g,'')" style="width:70px;margin-left:20px" v-model="settings.uploadLimit.value" size="mini"></el-input>
          <el-select v-if="settings.uploadLimit.is" style="width:85px;" v-model="settings.uploadLimit.unit" placeholder="" size="mini">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <span v-if="settings.uploadLimit.is&&settings.uploadLimit.value !==''"> = {{uploadValue}}</span>
          <span v-if="morethanUp" style="color:red;margin-left:20px">{{this.$lang.ui.prompt.l166}}</span>
        </div>
        <span class="mid-title min">
          {{message.Al195}}
        </span>
        <div class="tr">
          <el-checkbox class="check-box" v-model="settings.sp">
            {{message.Al169}}
          </el-checkbox>
        </div>
        <div class="tr">
          <el-checkbox class="check-box" v-model="settings.tcp">
            {{message.Al170}}
          </el-checkbox>
        </div>
        <span class="mid-title min">
          {{message.Al196}}
        </span>
        <div class="tr">
          <el-checkbox class="check-box" v-model="settings.encryption">
            {{message.Al168}}
          </el-checkbox>
        </div>
        <span class="mid-title min">
          {{message.Al197}}
        </span>
        <div class="tr">
          <span style="position:absolute;left:0">{{message.Sl145}}</span>
          <el-radio-group v-model="settings.uploadTime.mode">
            <el-radio :label="0">{{message.Al198}}</el-radio>
            <el-radio :label="1">{{message.Al199}}</el-radio>
            <el-radio :label="2">
              {{message.Al200}}
                <el-time-picker
                  v-show="settings.uploadTime.mode===2"
                  value-format="HH:mm:ss"
                  size="mini"
                  :clearable="false"
                  style="width:120px"
                  v-model="settings.uploadTime.time"
                  placeholder="">
                </el-time-picker>
            </el-radio>
          </el-radio-group>
        </div>
        <div class="tr">
          <span style="position:absolute;left:0">{{message.Sl146}}</span>
          <el-radio-group v-model="settings.downloadTime">
            <el-radio :label="0">{{message.Al198}}</el-radio>
            <el-radio :label="1">{{message.Al199}}</el-radio>
          </el-radio-group>
        </div>
        <span class="mid-title min">
          {{message.Al201}}
        </span>
        <div class="tr">
          <span :class="{maxWidth: isMaxWidth}" style="color:#5a5e66">{{message.Al172}}</span>
          <el-select style="width:120px;margin-left:20px" v-model="settings.downloadNum" placeholder="" size="mini">
            <el-option
              v-for="item in options1"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="tr">
          <span :class="{maxWidth: isMaxWidth}" style="color:#5a5e66;">{{message.Al171}}</span>
          <el-select style="width:120px;margin-left:20px" v-model="settings.uploadNum" placeholder="" size="mini">
            <el-option
              v-for="item in options1"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="tr" style="text-align:center;padding:12px 0 0 0" v-show="showB">
           <el-button size="small" @click="setB" type="primary">{{message.Al210}}</el-button>
           <el-button size="small" @click="resetB">{{message.Fl101}}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Store from '@/store'
import _this from '@/main'
export default {
  beforeRouteEnter (to, from, next) {
    if (!Store.state.app.login && Store.state.app.login !== null) {
      _this.$app.login(0, response => {
        if (response === 2) {
          _this.$app.start()
        }
      })
    } else {
      next()
    }
  },
  beforeRouteLeave (to, from, next) {
    if (Object.keys(this.submitA).length || Object.keys(this.submitB).length) {
      this.$confirm(this.$lang.ui.notice.l141, this.$lang.ui.system.l133, {
        confirmButtonText: this.$lang.ui.form.l127,
        cancelButtonText: this.$lang.ui.form.l101,
        type: 'warning'
      }).then(() => {
        next()
      }).catch(() => {
        next(false)
      })
    } else {
      next()
    }
  },
  computed: {
    uploadValue: function () {
      var data = Math.pow(1000, this.settings.uploadLimit.unit) * parseFloat(this.settings.uploadLimit.value)
      data = this._global.bandwidthSwitch(data)
      return data
    },
    downloadValue: function () {
      var data = Math.pow(1000, this.settings.downloadLimit.unit) * parseFloat(this.settings.downloadLimit.value)
      data = this._global.bandwidthSwitch(data)
      return data
    }
  },
  components: {
  },
  watch: {
    settingsA: {
      handler (val) {
        if (val.folder !== this.settingsAOld.folder) {
          this.submitA['downloadDir'] = val.folder
        } else {
          delete this.submitA['downloadDir']
        }
        if (val.accountFolder !== this.settingsAOld.accountFolder) {
          this.submitA['subDirAccount'] = val.accountFolder
        } else {
          delete this.submitA['subDirAccount']
        }
        if (val.senderFolder !== this.settingsAOld.senderFolder) {
          this.submitA['subDirSender'] = val.senderFolder
        } else {
          delete this.submitA['subDirSender']
        }
        if (val.languages !== this.settingsAOld.languages) {
          this.submitA['languages'] = val.languages
        } else {
          delete this.submitA['languages']
        }
        if (val.dateFormat !== this.settingsAOld.dateFormat) {
          this.submitA['dateFormat'] = val.dateFormat
        } else {
          delete this.submitA['dateFormat']
        }
        if (Object.keys(this.submitA).length > 0) {
          this.showA = true
        } else {
          this.showA = false
        }
      },
      deep: true
    },
    settings: {
      handler (val) {
        var value = ''
        if (val.uploadLimit.is !== this.settingsOld.uploadLimit.is) {
          if (!val.uploadLimit.is) {
            this.submitB['maxUploadBitrate'] = 0
            this.morethanUp = false
          } else {
            this.submitB['maxUploadBitrate'] = Math.pow(1000, val.uploadLimit.unit) * parseFloat(val.uploadLimit.value)
            // console.log(this.submitB['maxUploadBitrate'])
            if (this.submitB['maxUploadBitrate'] > 2000000000) {
              this.morethanUp = true
            } else {
              this.morethanUp = false
            }
          }
        } else if (val.uploadLimit.is) {
          if (JSON.stringify(val.uploadLimit) !== JSON.stringify(this.settingsOld.uploadLimit)) {
            this.submitB['maxUploadBitrate'] = Math.pow(1000, val.uploadLimit.unit) * parseFloat(val.uploadLimit.value)
            if (this.submitB['maxUploadBitrate'] > 2000000000) {
              this.morethanUp = true
            } else {
              this.morethanUp = false
            }
          } else {
            delete this.submitB['maxUploadBitrate']
          }
        } else {
          this.morethanUp = false
          delete this.submitB['maxUploadBitrate']
        }
        if (val.downloadLimit.is !== this.settingsOld.downloadLimit.is) {
          if (!val.downloadLimit.is) {
            this.submitB['maxDownloadBitrate'] = 0
            this.morethanDown = false
          } else {
            this.submitB['maxDownloadBitrate'] = parseInt(Math.pow(1000, val.downloadLimit.unit) * parseFloat(val.downloadLimit.value))
            if (this.submitB['maxDownloadBitrate'] > 2000000000) {
              this.morethanDown = true
            } else {
              this.morethanDown = false
            }
          }
        } else if (val.downloadLimit.is) {
          if (JSON.stringify(val.downloadLimit) !== JSON.stringify(this.settingsOld.downloadLimit)) {
            this.submitB['maxDownloadBitrate'] = parseInt(Math.pow(1000, val.downloadLimit.unit) * parseFloat(val.downloadLimit.value))
            if (this.submitB['maxDownloadBitrate'] > 2000000000) {
              this.morethanDown = true
            } else {
              this.morethanDown = false
            }
          } else {
            delete this.submitB['maxDownloadBitrate']
          }
        } else {
          this.morethanDown = false
          delete this.submitB['maxDownloadBitrate']
        }
        if (val.tcp !== this.settingsOld.tcp) {
          val.tcp ? value = 1 : value = 0
          this.submitB['f2tpBackendType'] = value
        } else {
          delete this.submitB['f2tpBackendType']
        }
        if (val.encryption !== this.settingsOld.encryption) {
          val.encryption ? value = 5 : value = 0
          this.submitB['encryptionType'] = value
        } else {
          delete this.submitB['encryptionType']
        }
        if (val.sp !== this.settingsOld.sp) {
          val.sp ? value = 4 : value = 0
          this.submitB['treatSmallFileType'] = value
        } else {
          delete this.submitB['treatSmallFileType']
        }
        if (val.uploadNum !== this.settingsOld.uploadNum) {
          this.submitB['maxUploadConcurrentNum'] = val.uploadNum
        } else {
          delete this.submitB['maxUploadConcurrentNum']
        }
        if (val.downloadNum !== this.settingsOld.downloadNum) {
          this.submitB['maxDownloadConcurrentNum'] = val.downloadNum
        } else {
          delete this.submitB['maxDownloadConcurrentNum']
        }
        if (val.downloadTime !== this.settingsOld.downloadTime) {
          this.submitB['downloadPlanMode'] = val.downloadTime
        } else {
          delete this.submitB['downloadPlanMode']
        }
        if (val.uploadTime.mode !== this.settingsOld.uploadTime.mode) {
          this.submitB['uploadPlanMode'] = val.uploadTime.mode
        } else {
          delete this.submitB['uploadPlanMode']
        }
        if (val.uploadTime.mode === 2) {
          if (val.uploadTime.time !== this.settingsOld.uploadTime.time) {
            this.submitB['uploadPlanTime'] = val.uploadTime.time
          } else {
            delete this.submitB['uploadPlanTime']
          }
        }
        if (Object.keys(this.submitB).length > 0) {
          this.showB = true
        } else {
          this.showB = false
        }
      },
      deep: true
    }
  },
  data () {
    return {
      message: {
        Al162: this.$lang.ui.app.l162,
        Al163: this.$lang.ui.app.l163,
        Al164: this.$lang.ui.app.l164,
        Al165: this.$lang.ui.app.l165,
        Al166: this.$lang.ui.app.l166,
        Al167: this.$lang.ui.app.l167,
        Al168: this.$lang.ui.app.l168,
        Al169: this.$lang.ui.app.l169,
        Al170: this.$lang.ui.app.l170,
        Al171: this.$lang.ui.app.l171,
        Al172: this.$lang.ui.app.l172,
        Al173: this.$lang.ui.app.l173,
        Al174: this.$lang.ui.app.l174,
        Al175: this.$lang.ui.app.l175,
        Al194: this.$lang.ui.app.l194,
        Al195: this.$lang.ui.app.l195,
        Al196: this.$lang.ui.app.l196,
        Al197: this.$lang.ui.app.l197,
        Al198: this.$lang.ui.app.l198,
        Al199: this.$lang.ui.app.l199,
        Al200: this.$lang.ui.app.l200,
        Al201: this.$lang.ui.app.l201,
        Al202: this.$lang.ui.app.l202,
        Al203: this.$lang.ui.app.l203,
        Al204: this.$lang.ui.app.l204,
        Al210: this.$lang.ui.app.l210,
        Sl131: this.$lang.ui.system.l131,
        Sl145: this.$lang.ui.system.l145,
        Sl159: this.$lang.ui.system.l159,
        Sl146: this.$lang.ui.system.l146,
        Sl127: this.$lang.ui.system.l127,
        Sl232: this.$lang.ui.system.l232,
        Fl101: this.$lang.ui.form.l101,
        Fl102: this.$lang.ui.form.l102
      },
      morethanDown: false,
      morethanUp: false,
      scrollSettings: {
        maxScrollbarLength: 0
      },
      submitA: {},
      submitB: {},
      options: [
        {
          value: 0,
          label: 'bps'
        },
        {
          value: 1,
          label: 'Kbps'
        },
        {
          value: 2,
          label: 'Mbps'
        },
        {
          value: 3,
          label: 'Gbps'
        }
      ],
      options1: [
        {
          value: 1,
          label: '1'
        },
        {
          value: 2,
          label: '2'
        },
        {
          value: 3,
          label: '3'
        }
      ],
      options2: [
        {
          value: 1,
          label: 'yyyy-mm-dd'
        },
        {
          value: 2,
          label: 'mm-dd-yyyy'
        },
        {
          value: 3,
          label: 'dd-mm-yyyy'
        }
      ],
      settingsA: {
        folder: '',
        accountFolder: false,
        senderFolder: false,
        languages: this._global.config.language,
        dateFormat: Number(localStorage.getItem('dateSet'))
      },
      settingsAOld: {
        folder: '',
        accountFolder: false,
        senderFolder: false,
        languages: this._global.config.language,
        dateFormat: Number(localStorage.getItem('dateSet'))
      },
      settings: {
        uploadLimit: {
          is: false,
          value: '',
          unit: 2
        },
        downloadLimit: {
          is: false,
          value: '',
          unit: 2
        },
        tcp: false,
        encryption: false,
        sp: false,
        uploadNum: 1,
        downloadNum: 1,
        downloadTime: 0,
        uploadTime: {
          mode: 0,
          time: ''
        }
      },
      settingsOld: {},
      showA: false,
      showB: false,
      info: {
        version: '',
        kit: '',
        f2tp: ''
      },
      rules: {
      },
      isMaxWidth: this._global.config.language === 'en',
    }
  },
  mounted () {
    this.getSettings()
  },
  methods: {
    getSettings () {
      this.$app.info(response => {
        this.info.version = response.appVersion
        this.info.kit = response.cydexKitVersion
        this.info.f2tp = response.f2tpVersion
      })
      this.$app.getSettings(response => {
        this.settingsA.folder = response.downloadDir
        this.settingsA.accountFolder = response.subDirAccount
        this.settingsA.senderFolder = response.subDirSender
        this.settings.downloadNum = response.maxDownloadConcurrentNum
        this.settings.uploadNum = response.maxUploadConcurrentNum
        this.settings.uploadTime.mode = response.uploadPlanMode
        this.settings.uploadTime.time = response.uploadPlanTime
        this.settings.downloadTime = response.downloadPlanMode
        if (response.f2tpBackendType === 0) {
          this.settings.tcp = false
        } else if (response.f2tpBackendType === 1) {
          this.settings.tcp = true
        }
        if (response.treatSmallFileType === 0) {
          this.settings.sp = false
        } else if (response.treatSmallFileType === 4) {
          this.settings.sp = true
        }
        if (response.encryptionType === 0) {
          this.settings.encryption = false
        } else if (response.encryptionType === 5) {
          this.settings.encryption = true
        }
        if (response.maxUploadBitrate === 0) {
          this.settings.uploadLimit.is = false
        } else {
          this.settings.uploadLimit.is = true
          this.settings.uploadLimit.value = this._global.bps(response.maxUploadBitrate).value
          this.settings.uploadLimit.unit = this._global.bps(response.maxUploadBitrate).unit
        }
        if (response.maxDownloadBitrate === 0) {
          this.settings.downloadLimit.is = false
        } else {
          this.settings.downloadLimit.is = true
          this.settings.downloadLimit.value = this._global.bps(response.maxDownloadBitrate).value
          this.settings.downloadLimit.unit = this._global.bps(response.maxDownloadBitrate).unit
        }
        this.settingsOld = JSON.parse(JSON.stringify(this.settings))
        this.settingsAOld = JSON.parse(JSON.stringify(this.settingsA))
      })
      if (this.settingsA.dateFormat === 0) {
        this.settingsA.dateFormat = 1
      }
      // console.log(this.settingsA.dateFormat)
    },
    setA () {
      if (!this.submitA['languages']) {
        this.setAApp()
        this.setDate()
      } else {
        if (Object.keys(this.submitA).length > 1) {
          delete this.submitA['languages']
          this.setAApp()
          this.setALanguages()
          this.setDate()
        } else {
          this.setALanguages()
        }
      }
    },
    setALanguages () {
      localStorage.setItem('langSet', this.settingsA.languages)
      let params = {
        language: this.settingsA.languages === 'zh-cn' ? 'zh-cn' : 'en',
        time_zone: this._global.config.timezone,
      }
      this.$api.changeTimezone(params)
      if (this.settingsA.languages === 'zh-cn') {
        var l = 1
      } else {
        l = 0
      }
      this.$app.setOption(l, response => {
        setTimeout(() => {
          // debugger
          window.location.reload()
        }, 300)
      })
    },
    setAApp () {
      this.$app.setSettings(this.submitA, response => {
        this.$message({
          message: this.$lang.ui.prompt.l117,
          type: 'success',
          duration: 4000
        })
        this.showA = false
        this.settingsAOld.folder = JSON.parse(JSON.stringify(this.settingsA.folder))
      })
    },
    setDate () {
      this.settingsAOld.dateFormat = JSON.parse(JSON.stringify(this.settingsA.dateFormat))
      localStorage.setItem('dateSet', this.settingsA.dateFormat)
      delete this.submitA['dateFormat']
    },
    resetA () {
      this.submitA = {}
      this.showA = false
      this.settingsA = JSON.parse(JSON.stringify(this.settingsAOld))
    },
    setB () {
      if (this.morethanDown || this.morethanUp) {
        this.$message({
          message: this.$lang.ui.prompt.l166,
          type: 'error',
          duration: 4000
        })
        return
      }
      if (this.settings.uploadLimit.is) {
        if (!this.settings.uploadLimit.value || isNaN(this.settings.uploadLimit.value)) {
          delete this.submitB['maxUploadBitrate']
          this.settings.uploadLimit.is = false
          this.settings.uploadLimit.value = ''
        }
      }
      if (this.settings.downloadLimit.is) {
        if (!this.settings.downloadLimit.value || isNaN(this.settings.downloadLimit.value)) {
          delete this.submitB['maxDownloadBitrate']
          this.settings.downloadLimit.is = false
          this.settings.downloadLimit.value = ''
        }
      }
      this.$app.setSettings(this.submitB, response => {
        this.$message({
          message: this.$lang.ui.prompt.l117,
          type: 'success',
          duration: 4000
        })
        this.showB = false
        this.submitB = {}
        this.settingsOld = JSON.parse(JSON.stringify(this.settings))
      })
    },
    resetB () {
      this.submitB = {}
      this.settings = JSON.parse(JSON.stringify(this.settingsOld))
      this.showB = false
      this.morethanDown = false
      this.morethanUp = false
    },
    changeFolder () {
      this.$app.appFolder(response => {
        if (response.selectedFolder !== '') {
          this.settingsA.folder = response.selectedFolder
        }
      })
    },
    openLog () {
      this.$app.openLog()
    }
  }
}
</script>

<style scoped lang="css">
.main {
  width: 100%;
  min-width: 710px;
  padding-bottom: 60px;
}
.name {
  width: 100%;
  height: 50px;
  margin-top: 10px;
}
.close {
  float: right;
  margin: 11px;
  margin-right: 18px;
  cursor: pointer;
}
.left {
  float: left;
  margin: 11px;
  margin-right: 18px;
  cursor: pointer;
}
.title {
  display: block;
  height: 100%;
  line-height: 50px;
  float: left;
  margin-left: 20px;
  font-size: 16px;
  font-weight: 600;
}
.title.medium {
  display: block;
  margin: 0 auto;
  height: auto;
  font-size: 14px;
  float: none;
  padding-left: 20px;
}
.box {
  width: 100%;
}
.ticket-more {
  width: 100%;
  padding: 20px;
}
.cell {
  margin: 0 auto;
  background-color: #f0f0f0;
  border-radius: 2px;
  padding: 0 35px 35px 35px;
  margin-bottom: 10px;
}
.tr {
  position: relative;
  width: 100%;
  height: 34px;
  line-height: 34px;
  padding-left: 140px;
}
.bottom-button {
  text-align: right;
  width: 100%;
  padding: 25px;
}
.change {
  margin-left: 20px;
  cursor: pointer;
  color: #007bc5;
}
.change:hover {
  font-weight: 600;
}
.log {
  cursor: pointer;
  color: #007bc5;
}
.log:hover {
  font-weight: 600;
}
.mid-title {
  display: block;
  height: 35px;
  width: 140px;
  line-height: 102px;
}
.mid-title.min {
  height: 17px;
  line-height: 68px;
}
.maxWidth {
  display: inline-block;
  width: 200px;
}
</style>
